import { useDroppable } from '@dnd-kit/core';
import { HorisontalArrowDropzoneIcon } from '@ui/kit/icons';
import { inTextDropzoneInput } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../../../../state/context.data.js';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useInputState } from '../../hook.use-input-state.js';
import { DraggableTile } from './atom.draggable.js';
import { PlaceItemsInTextTile } from './atom.tile.js';
import { filledDropzone, emptyDropzone, placeholder } from './input.dropzone.style.js';
import { jsx } from 'react/jsx-runtime';

function PlaceItemsInTextDropzone(props) {
  const component = useOpgavekompleksetComponent();
  const {
    setNodeRef,
    isOver
  } = useDroppable({
    id: props.dropzone.id,
    disabled: !props.draggable
  });
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => inTextDropzoneInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.dropzone.id])
  });
  const state = useInputState(props.dropzone, inputEntry);
  const tileWithinId = props.facitType === "should-have" && state !== "correct" ? props.tiles.find(it => props.dropzone.validation.acceptedTileKeys.includes(it.itemKey))?.id : inputEntry?.tileId;
  const tileWithin = tileWithinId ? props.tiles.find(it => it.id === tileWithinId) : undefined;
  const tileState = props.facitType === "user-entry" ? state : props.dropzone.validation.acceptedTileKeys.includes(inputEntry?.tileKey ?? "") ? "correct" : "should-have";
  if (tileWithin) {
    return /*#__PURE__*/jsx("div", {
      ref: setNodeRef,
      className: filledDropzone,
      "data-over": isOver,
      children: props.draggable ? /*#__PURE__*/jsx(DraggableTile, {
        tile: tileWithin,
        context: "dropzone",
        state: tileState,
        taskEntryKey: props.taskEntryKey,
        isDraggingItem: props.draggedItemId === tileWithin.id
      }, tileWithinId) : /*#__PURE__*/jsx(PlaceItemsInTextTile, {
        context: "dropzone",
        taskEntryKey: props.taskEntryKey,
        tile: tileWithin,
        state: tileState
      }, tileWithinId)
    });
  }
  return /*#__PURE__*/jsx("div", {
    ref: setNodeRef,
    className: emptyDropzone,
    "data-over": isOver,
    "data-audience": component.data.settings.standalone.audience,
    children: /*#__PURE__*/jsx("div", {
      className: placeholder,
      children: /*#__PURE__*/jsx(HorisontalArrowDropzoneIcon, {})
    })
  });
}

export { PlaceItemsInTextDropzone };
//# sourceMappingURL=input.dropzone.js.map
